import { render, staticRenderFns } from "./CollateralFolderMenuContainer.vue?vue&type=template&id=fbb462e4&scoped=true&"
import script from "./CollateralFolderMenuContainer.vue?vue&type=script&lang=js&"
export * from "./CollateralFolderMenuContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb462e4",
  null
  
)

export default component.exports